import React from 'react'

const DesktopMacIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='36'
    height='36'
    viewBox='0 0 36 36'
    fill='none'
    {...props}
  >
    <path
      d='M12.3279 31.4941V30.0358L15.2445 27.1191H6.49455C5.69246 27.1191 5.00583 26.8336 4.43465 26.2624C3.86347 25.6912 3.57788 25.0046 3.57788 24.2025V8.16081C3.57788 7.35872 3.86347 6.67209 4.43465 6.10091C5.00583 5.52973 5.69246 5.24414 6.49455 5.24414H29.8279C30.63 5.24414 31.3166 5.52973 31.8878 6.10091C32.459 6.67209 32.7446 7.35872 32.7446 8.16081V24.2025C32.7446 25.0046 32.459 25.6912 31.8878 26.2624C31.3166 26.8336 30.63 27.1191 29.8279 27.1191H21.0779L23.9945 30.0358V31.4941H12.3279Z'
      fill='currentcolor'
    />
  </svg>
)

export default DesktopMacIcon
